import {
    IconCancel,
    IconEdit
} from '../../componentes/Icons';
import './GestaoEquipe.css';

const TeamSection = ({
    editingBarberId,
    newBarberImage,
    handleFileChange,
    newBarberName,
    setNewBarberName,
    barberWorkingHours,
    setBarberWorkingHours,
    handleAddBarber,
    setEditingBarberId,
    setNewBarberImage,
    barbers,
    currentTenant,
    handleDeleteBarber,
    newBarberEmail,
    setNewBarberEmail,
    newBarberPhone,
    setNewBarberPhone,
    newBarberRole,
    setNewBarberRole
}) => {
    return (
        <div className="section-team fade-in">
            <div className="admin-grid-layout">
                <div className="admin-card">
                    <h3 className="card-title">{editingBarberId ? 'Editar Barbeiro' : 'Adicionar Barbeiro'}</h3>
                    <div className="modern-form">
                        <div className="barber-upload-preview" onClick={() => document.getElementById('barber-file').click()}>
                            <img src={newBarberImage || '/imagens/fotobarber.PNG'} alt="Preview" />
                            <div className="upload-overlay"><span>Alterar Foto</span></div>
                        </div>
                        <input
                            type="file"
                            id="barber-file"
                            hidden
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, 'barber')}
                        />
                        <div className="form-group">
                            <label>Nome do Barbeiro</label>
                            <input
                                type="text"
                                placeholder="Ex: João Silva"
                                value={newBarberName}
                                onChange={(e) => setNewBarberName(e.target.value)}
                                className="modern-input"
                            />
                        </div>

                        <div className="form-group">
                            <label>E-mail de Acesso</label>
                            <input
                                type="email"
                                placeholder="email@exemplo.com"
                                value={newBarberEmail || ''}
                                onChange={(e) => setNewBarberEmail(e.target.value)}
                                className="modern-input"
                            />
                            <small style={{ color: 'rgba(255,255,255,0.4)', marginTop: '4px', display: 'block' }}>
                                A pessoa usará este e-mail para entrar no painel.
                            </small>
                        </div>

                        <div className="form-group-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                            <div className="form-group">
                                <label>WhatsApp</label>
                                <input
                                    type="text"
                                    placeholder="(00) 00000-0000"
                                    value={newBarberPhone || ''}
                                    onChange={(e) => setNewBarberPhone(e.target.value)}
                                    className="modern-input"
                                />
                            </div>
                            <div className="form-group">
                                <label>Cargo / Acesso</label>
                                <select
                                    className="modern-input"
                                    value={newBarberRole || 'barber'}
                                    onChange={(e) => setNewBarberRole(e.target.value)}
                                    style={{ background: 'rgba(255,255,255,0.05)', color: '#fff' }}
                                >
                                    <option value="barber">Equipe (Acesso Agenda)</option>
                                    <option value="admin">Administrador (Total)</option>
                                </select>
                            </div>
                        </div>

                        <div className="working-hours-container">
                            <label className="section-label-sm">Horário de Trabalho</label>
                            <div className="working-hours-grid">
                                {Object.entries(barberWorkingHours).map(([day, config]) => (
                                    <div key={day} className={`day-row-premium ${config.active ? 'active' : ''}`}>
                                        <div className="day-main-info">
                                            <div className="day-name">
                                                <input
                                                    type="checkbox"
                                                    checked={config.active}
                                                    onChange={(e) => setBarberWorkingHours({
                                                        ...barberWorkingHours,
                                                        [day]: { ...config, active: e.target.checked }
                                                    })}
                                                />
                                                <span>{day}</span>
                                            </div>
                                            <div className="day-times">
                                                <input
                                                    type="time"
                                                    value={config.start}
                                                    disabled={!config.active}
                                                    onChange={(e) => setBarberWorkingHours({
                                                        ...barberWorkingHours,
                                                        [day]: { ...config, start: e.target.value }
                                                    })}
                                                />
                                                <span>às</span>
                                                <input
                                                    type="time"
                                                    value={config.end}
                                                    disabled={!config.active}
                                                    onChange={(e) => setBarberWorkingHours({
                                                        ...barberWorkingHours,
                                                        [day]: { ...config, end: e.target.value }
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        {config.active && (
                                            <div className="day-lunch-break">
                                                <div className="lunch-toggle">
                                                    <input
                                                        type="checkbox"
                                                        checked={config.lunchActive}
                                                        onChange={(e) => setBarberWorkingHours({
                                                            ...barberWorkingHours,
                                                            [day]: { ...config, lunchActive: e.target.checked }
                                                        })}
                                                    />
                                                    <label>Intervalo / Almoço</label>
                                                </div>
                                                {config.lunchActive && (
                                                    <div className="lunch-times fade-in">
                                                        <input
                                                            type="time"
                                                            value={config.lunchStart}
                                                            onChange={(e) => setBarberWorkingHours({
                                                                ...barberWorkingHours,
                                                                [day]: { ...config, lunchStart: e.target.value }
                                                            })}
                                                        />
                                                        <span>até</span>
                                                        <input
                                                            type="time"
                                                            value={config.lunchEnd}
                                                            onChange={(e) => setBarberWorkingHours({
                                                                ...barberWorkingHours,
                                                                [day]: { ...config, lunchEnd: e.target.value }
                                                            })}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="form-actions-row" style={{ display: 'flex', gap: '10px' }}>
                            <button
                                className="modern-btn primary"
                                style={{ flex: 1 }}
                                onClick={handleAddBarber}
                            >
                                {editingBarberId ? 'Salvar Alterações' : 'Cadastrar Barbeiro'}
                            </button>
                            {editingBarberId && (
                                <button
                                    className="modern-btn"
                                    style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' }}
                                    onClick={() => {
                                        setEditingBarberId(null);
                                        setNewBarberName('');
                                        setNewBarberEmail('');
                                        setNewBarberPhone('');
                                        setNewBarberRole('barber');
                                        setNewBarberImage('/imagens/fotobarber.PNG');
                                    }}
                                >Cancelar</button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="admin-card main-list-card">
                    <h3 className="card-title">Equipe Cadastrada</h3>
                    <div className="barber-items-grid">
                        {barbers.map(barber => (
                            <div key={barber.id} className="barber-mini-card">
                                <img src={barber.image} alt={barber.name} />
                                <div className="barber-info">
                                    <h4>{barber.name}</h4>
                                    <span>{currentTenant}</span>
                                </div>
                                <div className="barber-card-actions">
                                    <button
                                        className="action-btn edit"
                                        onClick={() => {
                                            setNewBarberName(barber.name);
                                            setNewBarberImage(barber.image);
                                            setNewBarberEmail(barber.email || '');
                                            setNewBarberPhone(barber.whatsapp || '');
                                            setNewBarberRole(barber.role || 'barber');
                                            setEditingBarberId(barber.id);
                                            if (barber.workingHours) {
                                                setBarberWorkingHours(barber.workingHours);
                                            }
                                            document.querySelector('.section-team').scrollIntoView({ behavior: 'smooth' });
                                        }}
                                        title="Editar"
                                    ><IconEdit /></button>
                                    <button
                                        className="action-btn cancel"
                                        onClick={() => handleDeleteBarber(barber.id)}
                                        title="Excluir"
                                    ><IconCancel /></button>
                                </div>
                            </div>
                        ))}
                        {barbers.length === 0 && <p className="empty-msg">Nenhum barbeiro cadastrado.</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamSection;
